import * as types from "../actions/actionTypes";
import getUserIdentification from "../assets/getUserIdentification";
const initialState = {
  loading: true,
  data: null,
  project_status: false,
  userNotVerified: false,
  serverInterruptStatus: ""
};

const Init = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_REQUEST:
      return { ...state, loading: true };
    case types.INIT_SUCCESS:
      let payLoad = JSON.parse(JSON.stringify(action.payLoad));
      if (payLoad.data && payLoad.data.data) {
        // let fullName = "";
        // if (
        //   payLoad.data.data.user.name !== null &&
        //   payLoad.data.data.user.family !== null
        // ) {
        //   payLoad.data.data.user.fullName = `${payLoad.data.data.user.name} ${payLoad.data.data.user.family}`;
        // } else {
        //   payLoad.data.data.user.fullName = payLoad.data.data.user.phone_number;
        // }
        payLoad.data.data.user.fullName = getUserIdentification(payLoad.data.data.user);
        return {
          ...state,
          data: {
            ...{
              premium: payLoad.data.premium,
              premium_prices: payLoad.data.premium_prices,
            }
          },
          ...payLoad
        };
      } else if (payLoad.data && payLoad.data.project_setting) {
        return {
          ...state,
          data: {
            ...{
              data: { ...state.data.data },
              project_setting: payLoad.data.project_setting,
              premium: { ...state.data.premium, ...payLoad.data.premium },
              premium_prices: {...state.data.premium_prices, ...payLoad.data.premium_prices}
            }
          }
        };
      } else if (state.data && payLoad.data && payLoad.data.user) {
        return {
          ...state,
          data: {
            ...state.data,
            data: {
              ...state.data.data,
              user: {...payLoad.data.user, fullName: `${payLoad.data.user.name} ${payLoad.data.user.family}`},
              // fullName: `${payLoad.data.user.name} ${payLoad.data.user.family}`
            }
          }
        };
      } else if (payLoad.data && payLoad.data.premium) {
        return {
          ...state,
          data: {
            ...state.data,
            premium: payLoad.data.premium
          }
        };
      }
      else if (payLoad.data && !payLoad.data.premium && payLoad.data.project !== null) {
        return {...state};
      }
    case types.INIT_INTERNET_CONNECTION_STATUS:
      return {...state, ...action.payLoad};
    case types.INIT_FAILURE:
      return { ...state, ...action.payLoad };
    default:
      return state;
  }
};

export default Init;
